import { useEffect, useState } from 'react';
import './App.css';
import NowaApp from './NowaApp';
import { translate } from "./i18n";
import HolidaysContext from './HolidaysContext';
import HolidayService from './HolidayService';
import Header from './Header';

function App() {

  const [holidays, setHolidays] = useState<Array<Date>>([]);

  useEffect(() => {
    document.title = `Norges Bank - ${translate("title")}`
  }, []);

  useEffect(() => {
    HolidayService.get()
      .then(r => {
        setHolidays(r);
      })
      .catch(_ => console.warn("Could not fetch holidays from API"));
  }, []);

  return (
    <div>
      <Header />
      <div className="container dx-theme-generic-typography">
        <HolidaysContext.Provider value={{ holidays, setHolidays }}>
          <NowaApp />
        </HolidaysContext.Provider>
      </div>
    </div>
  );
}

export default App;
